import React, { useState, useEffect, useCallback } from 'react';
import { mktFetch, MARKETING_API } from './MarketingHubModal';

const API = MARKETING_API;

const ASPECTS = [
  { id: 'title', label: 'Title' },
  { id: 'body', label: 'Body' },
  { id: 'hashtags', label: 'Tags' },
  { id: 'hook', label: 'Hook' },
  { id: 'image_prompt', label: 'Prompt' },
  { id: 'graphic', label: 'Image' },
  { id: 'video_prompt', label: 'V.Prompt' },
  { id: 'video', label: 'Video' },
];

export default function MarketingDraftFeedback({ draftId, compact = false }) {
  const [byAspect, setByAspect] = useState({});
  const [pending, setPending] = useState(null);
  const [comment, setComment] = useState('');
  const [msg, setMsg] = useState('');

  const load = useCallback(() => {
    if (!draftId) return;
    mktFetch(`${API}/platform/drafts/${draftId}/feedback`)
      .then((r) => r.json())
      .then((d) => setByAspect(d.by_aspect || {}))
      .catch(() => {});
  }, [draftId]);

  useEffect(() => { load(); }, [load]);

  const submit = async (aspect, rating, feedbackComment) => {
    setMsg('');
    try {
      const res = await mktFetch(`${API}/platform/drafts/${draftId}/feedback`, {
        method: 'POST',
        body: JSON.stringify({ aspect, rating, comment: feedbackComment || undefined }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Feedback failed');
      setPending(null);
      setComment('');
      setByAspect(data.by_aspect || {});
      setMsg(rating > 0 ? 'Thanks — noted for learning.' : 'Feedback saved — will improve future drafts.');
    } catch (e) {
      setMsg(e.message);
    }
  };

  const onThumb = (aspect, rating) => {
    if (rating > 0) {
      submit(aspect, 1, '');
      return;
    }
    setPending({ aspect, rating });
    setComment('');
  };

  const aspectLabel = pending ? ASPECTS.find((a) => a.id === pending.aspect)?.label : '';

  return (
    <div className={`marketing-draft-feedback${compact ? ' marketing-draft-feedback-compact' : ''}`}>
      {!compact && <p className="marketing-source-meta">Rate each part — thumbs down asks what to fix; feeds back into Ollama.</p>}
      <div className="marketing-feedback-grid">
        {ASPECTS.map(({ id, label }) => {
          const cur = byAspect[id];
          return (
            <div key={id} className="marketing-feedback-aspect">
              <span className="marketing-feedback-label">{label}</span>
              <button
                type="button"
                className={`marketing-feedback-btn${cur?.rating === 1 ? ' is-active-up' : ''}`}
                title="Good"
                onClick={() => onThumb(id, 1)}
              >
                👍
              </button>
              <button
                type="button"
                className={`marketing-feedback-btn${cur?.rating === -1 ? ' is-active-down' : ''}`}
                title="Needs work"
                onClick={() => onThumb(id, -1)}
              >
                👎
              </button>
            </div>
          );
        })}
      </div>
      {pending && (
        <div className="marketing-feedback-comment-box">
          <label className="marketing-integration-label">
            What should improve for {aspectLabel}?
            <textarea
              rows={2}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="e.g. Too much archviz CGI — want documentary street photo"
            />
          </label>
          <div className="marketing-form-actions">
            <button
              type="button"
              className="blog-tactical-action-btn blog-tactical-action-edit"
              onClick={() => submit(pending.aspect, -1, comment.trim())}
            >
              SUBMIT FEEDBACK
            </button>
            <button type="button" className="blog-tactical-action-btn blog-tactical-action-delete" onClick={() => setPending(null)}>CANCEL</button>
          </div>
        </div>
      )}
      {msg && <p className="marketing-msg">{msg}</p>}
    </div>
  );
}
